export const RegionalExplicitEnum = Object.freeze({
    NO: 'NO',
    YES: 'YES',
    ERROR: 'ERROR',
});